<template>
  <!--Main-->
  <a-layout-footer class="footer">
    <div class="container">
      <a-row class="align-center">
        <!--Ubicacion-->
        <a-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8" class="text-left d-none">
          <div class="ubicacion">
            <HomeFilled :style="{ fontSize: '3rem', color: '#407ec9' }"/>
            <h5 class="pl">
              2a Av. Norte y 1a C Poniente.<br />
              No. 2-3, Distrito Santa Tecla.<br />
              La Libertad Sur, El Salvador
            </h5>
          </div>
        </a-col>

        <!--logo-->
        <a-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8" class="text-center d-none">
          <div class="logo">
            <img src="@/assets/logo.png" alt="Alcaldía de La Libertad Sur" />
          </div>
        </a-col>

        <!--Redes-->
        <a-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8" class="m-auto text-right text-middle">
          <div class="social-media p">
            <a-row class="text-center">
              <a-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <a href="tel:2500-1350">
                    <PhoneFilled :style="{ fontSize: '3rem' }"/>
                </a>
              </a-col>
              <a-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <a
                  href="https://es-la.facebook.com/SantaTeclaSV"
                  target="_blank"
                >
                <FacebookFilled :style="{ fontSize: '3rem' }"/>
                </a>
              </a-col>
              <a-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <a href="https://twitter.com/santateclasv" target="_blank">
                    <TwitterOutlined :style="{ fontSize: '3rem' }"/>
                </a>
              </a-col>
              <a-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <a
                  href="https://www.instagram.com/santateclasv/"
                  target="_blank"
                  class="instagram"
                >
                <InstagramOutlined :style="{ fontSize: '3rem' }"/>
                </a>
              </a-col>
            </a-row>
          </div>
        </a-col>

        <!--Año-->
        <a-col :span="24" class="pt mb-xs-2 text-center">
          <h5>Dirección de Innovación y Tecnología</h5>
          <h5>
            © {{ getYear() }} - Alcaldía de La Libertad Sur, Distrito Santa
            Tecla, La Libertad Sur, El Salvador. Todos los Derechos Reservados.
          </h5>
          <span class="version">Ver. {{ pjson.version }}</span>
        </a-col>
      </a-row>
    </div>
  </a-layout-footer>
</template>
  
  <script setup>
import pjson from "@/../package.json"
import { TwitterOutlined, FacebookFilled, InstagramOutlined, HomeFilled, PhoneFilled } from '@ant-design/icons-vue'

const getYear = () => {
  const dateData = new Date();
  const year = dateData.getFullYear();
  return year;
};
</script>

<style scoped>
.align-center {
  align-items: center;
}
.logo {
    height: 5rem;
    display: flex;
    justify-content: center;
}
.version {
    font-size: 9px;
}
.text-center {
    text-align: center;
}
.p {
    padding-top: 0;
    font-size: .85rem;
}
.pt {
  padding-top: 1rem;
}
.ubicacion {
    display: flex;
    justify-content: center;
    align-items: center;
}
.pl {
    padding-left: 1rem;
}
@media (max-width: 992px) {
    .d-none {
      display: none;
    }
    .p {
      padding: 1.5rem;
    }
}
</style>